import { queryOptions, skipToken } from '@tanstack/react-query';
import { isAsyncIterable } from '@trpc/server/unstable-core-do-not-import';
import { unwrapLazyArg, createTRPCOptionsResult, getClientArgs, buildQueryFromAsyncIterable } from './utils.mjs';

/**
 * @internal
 */ function trpcQueryOptions(args) {
    const { input, query, path, queryKey, opts } = args;
    const queryClient = unwrapLazyArg(args.queryClient);
    const inputIsSkipToken = input === skipToken;
    const queryFn = async (queryFnContext)=>{
        const actualOpts = {
            ...opts,
            trpc: {
                ...opts?.trpc,
                ...opts?.trpc?.abortOnUnmount ? {
                    signal: queryFnContext.signal
                } : {
                    signal: null
                }
            }
        };
        const queryKey = queryFnContext.queryKey;
        const result = await query(...getClientArgs(queryKey, actualOpts));
        if (isAsyncIterable(result)) {
            return buildQueryFromAsyncIterable(result, queryClient, queryKey);
        }
        return result;
    };
    return Object.assign(queryOptions({
        ...opts,
        queryKey,
        queryFn: inputIsSkipToken ? skipToken : queryFn
    }), {
        trpc: createTRPCOptionsResult({
            path
        })
    });
}

export { trpcQueryOptions };
